import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  Container,
  Paper,
  CircularProgress,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { useTheme } from "@mui/material/styles";
import Fade from "@mui/material/Fade";
import axios from "axios";
import Snack from "./Snack";

const ContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const snackbar = () => {
    return console.log("snackbar reached");
  };

  const handleCloseSnackbar = () => {
    setShowSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true

    try {
      const response = await axios.post(
        "https://sava-api.tbridge.africa/health/receive-contact-details",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        
        snackbar();

        setSnackbarMessage("Email sent successfully!");
        setShowSnackbar(true);
        setLoading(false); // Reset loading state

        // Reset the form data
        setFormData({
          fullname: "",
          message: "",
          email: "",
          phoneNumber: "",
        });
      } else {
        alert("Error submitting form!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    }
  };

  const [formData, setFormData] = useState({
    fullname: "",
    message: "",
    email: "",
    phoneNumber: "",
  });

  const theme = useTheme();

  return (
    <Fade in={true} timeout={1000}>
      <Container
        maxwidth={false}
        sx={{
          maxwidth: "1300px",
          marginTop: { xs: "0px", sm: "80px", lg: "50px" },
          marginBottom: { xs: "5px", sm: "80px", lg: "0px" },
        }}>
        <Box sx={{}}>
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              marginBottom: "20px",
            }}>
            Contact Us
          </Typography>

          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="stretch">
            {/* Left Column */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "600px",
                }}>
                <Box>
                  {/* Location */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column", // Stack icon above text
                      alignItems: "center", // Center horizontally
                    }}>
                    <LocationOnIcon
                      sx={{
                        color: theme.palette.primary.main,
                        fontSize: "20px",
                      }}
                    />
                    <Box sx={{ textAlign: "center", marginBottom: "1px" }}>
                      <Typography variant="body1">Mikocheni B</Typography>
                      <Typography variant="body1">CocaCola Road</Typography>
                      <Typography>Auditax House 1ˢᵗ Floor</Typography>
                      <Typography>Dar es Salaam, Tanzania</Typography>
                    </Box>
                  </Box>

                  {/* Phone */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column", // Stack icon above text
                      alignItems: "center", // Center horizontally
                    }}>
                    <PhoneIcon
                      sx={{
                        color: theme.palette.primary.main,
                        fontSize: "20px",
                        marginBottom: "1px",
                      }}
                    />
                    <Box sx={{ textAlign: "center" }}>
                      <Typography>+255 672 600 151</Typography>
                    </Box>
                  </Box>

                  {/* Email */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column", // Stack icon above text
                      alignItems: "center", // Center horizontally
                      marginBottom: "1px",
                    }}>
                    <EmailIcon
                      sx={{
                        color: theme.palette.primary.main,
                        fontSize: "20px",
                        marginBottom: "1px",
                      }}
                    />
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="body1">info@sava.co.tz</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    height: "400px",
                    width: "100%",
                    borderRadius: "8px", // Rounded corners for outer Box
                    overflow: "hidden", // Ensures content respects border radius
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Subtle shadow
                    border: "1px solid", // Blue border for outer Box
                    borderColor: theme.palette.primary.main,
                  }}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d507156.76567362633!2d39.240412!3d-6.75006!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c4b60ec3f77ad%3A0x68574580116366a0!2sAuditax%20International!5e0!3m2!1sen!2sus!4v1738322590155!5m2!1sen!2sus"
                    width="100%"
                    height="100%"
                    alt="location"
                    title="map"
                    style={{
                      border: "none", // Remove iframe border as Box already has one
                    }}
                    allowFullScreen=""
                    loading="lazy"></iframe>
                </Box>
              </Box>
            </Grid>

            {/* Right Column */}

            <Grid item xs={12} md={6}>
              <Paper
                sx={{
                  backgroundColor: "white",
                  padding: "20px",
                  margin: "auto",
                  height: "600px",
                }}>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      marginBottom: "20px",
                      fontWeight: "bold",
                      color: "black",
                    }}>
                    Get in Touch
                  </Typography>

                  <form onSubmit={handleSubmit}>
                    <TextField
                      fullWidth
                      label="Full Name"
                      variant="outlined"
                      name="fullname"
                      value={formData.fullname}
                      size="small"
                      onChange={handleChange}
                      required
                      sx={{
                        marginBottom: 2,
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#ccc" },
                          "&:hover fieldset": { borderColor: "#000" },
                          "&.Mui-focused fieldset": { borderColor: "#000" },
                        },
                        "& .MuiInputBase-input": {
                          color: "black", // Make entered text black
                        },
                      }}
                      SelectProps={{
                        native: true,
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Phone Number"
                      name="phoneNumber"
                      variant="outlined"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                      sx={{
                        marginBottom: 2,
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#ccc" },
                          "&:hover fieldset": { borderColor: "#000" },
                          "&.Mui-focused fieldset": { borderColor: "#000" },
                        },
                        "& .MuiInputBase-input": {
                          color: "black", // Make entered text black
                        },
                      }}
                      SelectProps={{
                        native: true,
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Email"
                      variant="outlined"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      sx={{
                        marginBottom: 2,
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#ccc" },
                          "&:hover fieldset": { borderColor: "#000" },
                          "&.Mui-focused fieldset": { borderColor: "#000" },
                        },
                        "& .MuiInputBase-input": {
                          color: "black", // Make entered text black
                        },
                      }}
                      SelectProps={{
                        native: true,
                      }}
                    />
                    <TextField
                      fullWidth
                      required
                      label="Message"
                      variant="outlined"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      multiline
                      rows={8}
                      sx={{
                        marginBottom: 2,
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#ccc" },
                          "&:hover fieldset": { borderColor: "#000" },
                          "&.Mui-focused fieldset": { borderColor: "#000" },
                        },
                        "& .MuiInputBase-input": {
                          color: "black", // Make entered text black
                        },
                      }}
                      SelectProps={{
                        native: true,
                      }}
                    />

                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      type="submit"
                      disabled={loading} // Disable button while loading
                      endIcon={
                        loading ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : null
                      } // Show spinner if loading
                    >
                      {loading ? "Loading..." : "Submit"}
                    </Button>

                    {showSnackbar && (
                      <Snack
                        open={showSnackbar}
                        handleClose={handleCloseSnackbar}
                      />
                    )}
                  </form>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Fade>
  );
};

export default ContactUs;
